import React from 'react';
import styles from './toggleButton.module.scss';

interface ToggleSwitchButtonProps {
  leftButtonName: string;
  rightButtonName: string;
  activeButtonName: string;
  className?: string;
  leftClickHandler: () => void;
  rightClickHandler: () => void;
}

const ToggleButtonSwitch = ({
  leftButtonName,
  rightButtonName,
  className,
  leftClickHandler,
  rightClickHandler,
  activeButtonName,
}: ToggleSwitchButtonProps) => {
  return (
    (<div
      className={`${styles['toggle-switch-btn-container']} ${styles[className]}`}
      data-palette="ToggleButtonSwitch">
      <button
        className={activeButtonName === leftButtonName && styles[`active`]}
        onClick={leftClickHandler}>
        <div className={styles['button-text']}>{leftButtonName}</div>
      </button>
      <button
        className={activeButtonName === rightButtonName && styles[`active`]}
        onClick={rightClickHandler}>
        <div className={styles['button-text']}>{rightButtonName}</div>
      </button>
    </div>)
  );
};

export default ToggleButtonSwitch;
